export default "__VITE_ASSET__086111d5__"